import React from "react"; 
import { Link } from "react-router-dom";    
import PaymentTermsListContent from "../../../components/Dashboard/PaymentTermsListContent";

const PaymentTermsList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Payment Terms </h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Payment Terms List</li>
        </ul>
      </div> */}

      <PaymentTermsListContent />
    </>
  );
};

export default PaymentTermsList;
